import API from '../config/api';
import React, { useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';

import { Card, Form, Button, Spinner, Row, Col } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import { useNavigate, Link } from 'react-router-dom';

import CustomNavbar from '../components/CustomNavbar';
import AuthBackground from '../components/AuthBackground';
import { authStyles, divineAuthStyles } from './ForgotPasswordPage';

function SignupPage() {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const signupHandler = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      setLoading(true);

      await axios.post(`${API}/users/register`, {
        name,
        email,
        phone,
        password
      });

      toast.success('Registration Successful');

      /* Announce the background-music control to the new user */
      window.dispatchEvent(new Event('show-music-hint'));

      setTimeout(() => {
        navigate('/login');
      }, 1500);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Registration Failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomNavbar />

      <div className="auth-wrap">
        <AuthBackground />

        <Card className="border-0 shadow-lg auth-card auth-card-wide auth-card-glass auth-divine">
          {/* Sacred syllable watermark */}
          <span className="ad-om" aria-hidden="true">
            ॐ
          </span>

          {/* Lamps burning at the top corners */}
          <span className="ad-lamp ad-lamp-left" aria-hidden="true">
            <span className="ad-flame" />
            🪔
          </span>
          <span className="ad-lamp ad-lamp-right" aria-hidden="true">
            <span className="ad-flame" />
            🪔
          </span>

          <Card.Body className="p-4 p-md-5 position-relative">
            <div className="text-center mb-4">
              <div className="auth-icon">🕉️</div>

              <h3 className="fw-bold mb-2 ad-title">Create Account</h3>

              <p className="text-muted mb-0">
                Join PoojaMart and begin your sacred shopping journey.
              </p>
            </div>

            <Form onSubmit={signupHandler}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Full Name</Form.Label>

                <div className="auth-input-group">
                  <span className="auth-input-icon">👤</span>

                  <Form.Control
                    type="text"
                    placeholder="John Doe"
                    className="auth-input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Email</Form.Label>

                    <div className="auth-input-group">
                      <span className="auth-input-icon">✉️</span>

                      <Form.Control
                        type="email"
                        placeholder="you@example.com"
                        className="auth-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Phone</Form.Label>

                    <div className="auth-input-group">
                      <span className="auth-input-icon">📱</span>

                      <Form.Control
                        type="tel"
                        placeholder="9876543210"
                        className="auth-input"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Password</Form.Label>

                    <div className="auth-input-group">
                      <span className="auth-input-icon">🔑</span>

                      <Form.Control
                        type={show ? 'text' : 'password'}
                        placeholder="Create password"
                        className="auth-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />

                      <button
                        type="button"
                        className="auth-eye"
                        onClick={() => setShow((s) => !s)}
                        aria-label={show ? 'Hide password' : 'Show password'}
                      >
                        {show ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label className="fw-semibold">
                      Confirm Password
                    </Form.Label>

                    <div className="auth-input-group">
                      <span className="auth-input-icon">🔑</span>

                      <Form.Control
                        type={show ? 'text' : 'password'}
                        placeholder="Re-enter password"
                        className="auth-input"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </div>

                    {confirmPassword && confirmPassword !== password && (
                      <small className="text-danger">
                        Passwords do not match
                      </small>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Button
                type="submit"
                className="w-100 fw-bold auth-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Creating account...
                  </>
                ) : (
                  'Sign Up'
                )}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <span className="text-muted">Already have an account? </span>
              <Link to="/login" className="auth-link">
                Login
              </Link>
            </div>
          </Card.Body>
        </Card>
      </div>

      <style>{authStyles}</style>
      <style>{divineAuthStyles}</style>
    </>
  );
}

export default SignupPage;
